export const ACTIONS = {
  CHANGE_PASSWORD: "change_password",
  SET_LOADING: "gen/set_loading",
  GET_USER_DETAILS: "gen/get_user_details",
  GET_CITIES: "gen/get_cities",
  GET_PIN_CODE: "gen/get_pin_code",
  GET_AREA: "gen/get_area",
  UPLOAD_FILE: "gen/upload",
  GET_PANEL_USERS: "gen/get_panel_user",
  CREATE_PROJECT_SAMPLES: "gen/create_project_samples",
  GET_PROJECTS_SAMPLE: "gen/get_projects_samples",
  GET_PROJECTS: "gen/get_projects",
  UPDATE_SAMPLE_DATA: 'gen/update_sample_data',
  GET_APPLICATIONS: "gen/get_applications",
  GET_PROJECTS_FILTER: "gen/get_projects_filter",
  GET_PROJECTS_SAMPLE_ALL_DATA: "gen/get_projects_samples_all_data",
  CREATE_SAMPLES_STORAGE: "gen/create_samples_storage",
  GET_PROJECTS_SAMPLE_LIST: "gen/get_projects_sample_list",
  CREATE_SAMPLES_QC: "gen/create_sample_qc",
  UPLOAD_MEDIA_FILES: "gen/upload_files",
  GET_UPLOAD_MEDIA: "gen/get_upload_media",
  GET_SAMPLE_PROJECT_DATA: "gen/get_sample_project_data",
  CREATE_LIBRARY: "gen/create_library",
  GET_BOOKING_OVERVIEW: "gen/get_booking_overview",
  UPDATE_SAMPLES_QC: "gen/update_sample_qc",
  UPDATE_SAMPLES_STORAGE: "gen/update_samples_storage",
  UPDATE_LIBRARY: "gen/update_library",
  GET_DISPLAY_CITIES: "gen/get_display_cities",
  GET_AGENTS_BY_USERGROUP: "gen/get_agents_by_usergroup",
  CREATE_RUN_PLAN: "gen/run_plan_validate",
  GET_RUN_PLAN: "gen/get_run_plan",
  GET_CONFIG_DATA: "gen/get_config_data",
  CREATE_SEQUENCING: "gen/create_sequencing",
  GET_SEQUENCING: "gen/get_sequencing",
  UPDATE_SEQUENCING: "gen/update_sequencing",
  UPDATE_SEQUENCING_QC: "gen/update_sequencing_qc",
  POST_BIOINFORMATICS: "gen/post_bioinformatics",
  UPDATE_BIOINFORMATICS: "gen/update_bioinformatics",
  GET_BIO_INFORMATICS: "gen/get_bio_informatics",
  POST_DELIVERABLE: "gen/post_deliverable",
  UPDATE_DELIVERABLE: "gen/update_deliverable",
  FETCH_FINAL_REPORT: "gen/fetch_final_report",
  POST_CLOSE_PROJECT: 'gen/post_close_projects',
  UPDATE_DATA_FULLFILL: 'gen/update_data_fullfill',
  UPLOAD_STORAGE: 'gen/upload_storage',
  UPDATE_PROJECT: "gen/update_project",
  UPLOAD_REPORT: "gen/upload_report",
  UPLOAD_SAMPLE_QC: "gen/upload_sample_qc",
  UPLOAD_SAMPLE_LIBRARY: "gen/upload_sample_library",
  RESET_PROJECT: "gen/reset_project",
};

interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}

interface UploadLibrary {
  type: typeof ACTIONS.UPLOAD_SAMPLE_LIBRARY;
  payload: Object;
}
interface UploadSampleQc {
  type: typeof ACTIONS.UPLOAD_SAMPLE_QC;
  payload: Object;
}
interface UploadReport {
  type: typeof ACTIONS.UPLOAD_REPORT;
  payload: Object;
}
interface UpdateProject {
  type: typeof ACTIONS.UPDATE_PROJECT;
  payload: Object;
}
interface UploadStorageFile {
  type: typeof ACTIONS.UPLOAD_STORAGE;
  payload: Object;
}
interface postCloseProject {
  type: typeof ACTIONS.POST_CLOSE_PROJECT;
  payload: boolean;
}
interface postProjectFullFill {
  type: typeof ACTIONS.UPDATE_DATA_FULLFILL;
  payload: boolean;
}
interface FetchFinalReportData {
  type: typeof ACTIONS.FETCH_FINAL_REPORT;
  payload: boolean;
}
interface UpdateFinalReport {
  type: typeof ACTIONS.UPDATE_DELIVERABLE;
  payload: boolean;
}
interface PostFinalReport {
  type: typeof ACTIONS.POST_DELIVERABLE;
  payload: boolean;
}
interface FetchBioInformatics {
  type: typeof ACTIONS.GET_BIO_INFORMATICS;
  payload: boolean;
}
interface UpdateBioInformatics {
  type: typeof ACTIONS.UPDATE_BIOINFORMATICS;
  payload: boolean;
}
interface PostBioInformatics {
  type: typeof ACTIONS.POST_BIOINFORMATICS;
  payload: boolean;
}
interface UpdateSequencing {
  type: typeof ACTIONS.UPDATE_SEQUENCING;
  payload: boolean;
}
interface UpdateSequencingQc {
  type: typeof ACTIONS.UPDATE_SEQUENCING_QC;
  payload: boolean;
}
interface GetSequencing {
  type: typeof ACTIONS.GET_SEQUENCING;
  payload: boolean;
}
interface CreateSequencing {
  type: typeof ACTIONS.CREATE_SEQUENCING;
  payload: boolean;
}
interface GetOverviewdata {
  type: typeof ACTIONS.GET_BOOKING_OVERVIEW;
  payload: boolean;
}
interface RunPlan {
  type: typeof ACTIONS.CREATE_RUN_PLAN;
  payload: boolean;
}
interface updateLibrary {
  type: typeof ACTIONS.UPDATE_LIBRARY;
  payload: boolean;
}
interface updateSampleQc {
  type: typeof ACTIONS.UPDATE_SAMPLES_QC;
  payload: boolean;
}
interface updateSampleStorage {
  type: typeof ACTIONS.UPDATE_SAMPLES_STORAGE;
  payload: boolean;
}
interface GetAllSampleData {
  type: typeof ACTIONS.GET_SAMPLE_PROJECT_DATA;
  payload: boolean;
}
interface CreateLibrary {
  type: typeof ACTIONS.CREATE_LIBRARY;
  payload: boolean;
}
interface UploadMediaFiles {
  type: typeof ACTIONS.UPLOAD_MEDIA_FILES;
  payload: boolean;
}
interface GetUploadMedia {
  type: typeof ACTIONS.GET_UPLOAD_MEDIA;
  payload: boolean;
}
interface SampleQc {
  type: typeof ACTIONS.CREATE_SAMPLES_QC;
  payload: Object;
}
interface SampleList {
  type: typeof ACTIONS.GET_PROJECTS_SAMPLE_LIST;
  payload: Object;
}
interface SampleStorageData {
  type: typeof ACTIONS.CREATE_SAMPLES_STORAGE;
  payload: Object;
}
interface ProjectSampleAllData {
  type: typeof ACTIONS.GET_PROJECTS_SAMPLE_ALL_DATA;
  payload: Object;
}
interface ProjectFilterData {
  type: typeof ACTIONS.GET_PROJECTS_FILTER;
  payload: Object;
}
interface GetApplications {
  type: typeof ACTIONS.GET_APPLICATIONS;
  payload: boolean;
}
interface UpdateSamples {
  type: typeof ACTIONS.UPDATE_SAMPLE_DATA;
  payload: Object;
}
interface GetProject {
  type: typeof ACTIONS.GET_PROJECTS;
  payload: boolean;
}
interface GetProjectSample {
  type: typeof ACTIONS.GET_PROJECTS_SAMPLE;
  payload: boolean;
}
interface CreateProjectSample {
  type: typeof ACTIONS.CREATE_PROJECT_SAMPLES;
  payload: boolean;
}
interface SetLoading {
  type: typeof ACTIONS.SET_LOADING;
  payload: boolean;
}
interface GetUserDetails {
  type: typeof ACTIONS.GET_USER_DETAILS;
  payload: Object;
}

interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}
interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface GetUserGetails {
  type: typeof ACTIONS.GET_USER_DETAILS;
  payload: Array<any>;
}
interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}

interface UploadFile {
  type: typeof ACTIONS.UPLOAD_FILE;
  payload: Object;
}

interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}
interface GetArea {
  type: typeof ACTIONS.GET_AREA;
  payload: Array<any>;
}
interface SetLoading {
  type: typeof ACTIONS.SET_LOADING;
  payload: boolean;
}
interface GetPinCode {
  type: typeof ACTIONS.GET_PIN_CODE;
  payload: Array<any>;
}
interface ChangePassword {
  type: typeof ACTIONS.CHANGE_PASSWORD;
  payload: Object;
}
interface GetCities {
  type: typeof ACTIONS.GET_CITIES;
  payload: Array<any>;
}

interface GetArea {
  type: typeof ACTIONS.GET_AREA;
  payload: Array<any>;
}
interface SetLoading {
  type: typeof ACTIONS.SET_LOADING;
  payload: boolean;
}
interface GetDisplayCities {
  type: typeof ACTIONS.GET_DISPLAY_CITIES;
  payload: Array<any>;
}
interface GetAgentByUserGroup {
  type: typeof ACTIONS.GET_AGENTS_BY_USERGROUP;
  payload: Object;
}
interface GetRunPlan {
  type: typeof ACTIONS.GET_RUN_PLAN;
  payload: Object;
}
interface GetConfigData {
  type: typeof ACTIONS.GET_CONFIG_DATA;
  payload: Object;
}

interface ResetProject {
  type: typeof ACTIONS.RESET_PROJECT;
  payload: Object;
}

// RESET_PROJECT

export type PhlebognadminTypes =
  | ChangePassword
  | SetLoading
  | GetUserDetails
  | GetCities
  | GetPinCode
  | GetPinCode
  | ChangePassword
  | GetCities
  | GetArea
  | SetLoading
  | UploadFile
  | GetPinCode
  | ChangePassword
  | GetCities
  | GetArea
  | SetLoading
  | GetUserGetails
  | CreateProjectSample
  | GetProjectSample
  | GetProject
  | UpdateSamples
  | GetApplications
  | ProjectFilterData
  | ProjectSampleAllData
  | SampleStorageData
  | SampleList
  | SampleQc
  | UploadMediaFiles
  | GetUploadMedia
  | GetAllSampleData
  | CreateLibrary
  | GetOverviewdata
  | updateSampleQc
  | updateSampleStorage
  | updateLibrary
  | GetDisplayCities
  | GetAgentByUserGroup
  | RunPlan
  | GetRunPlan
  | GetConfigData
  | ResetProject
  | CreateSequencing
  | GetSequencing
  | UpdateSequencing
  | UpdateSequencingQc
  | PostBioInformatics
  | UpdateBioInformatics
  | FetchBioInformatics
  | PostFinalReport
  | UpdateFinalReport
  | FetchFinalReportData
  | postCloseProject
  | postProjectFullFill
  | UploadStorageFile
  | UpdateProject
  | UploadReport
  | UploadSampleQc
  | UploadLibrary



















